import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { Config } from '../config/env.config';
import { BaseHttpService } from '../base/_base-http.service';
import { contentHeaders } from 'common/headers';
import * as _ from 'lodash';
import {catchError} from 'rxjs/operators';
import { Subject } from 'rxjs';

@Injectable()
export class PriceSheetService extends BaseHttpService {

  isSavedSubject: Subject<void> = new Subject<void>();
  isSavedObservable = this.isSavedSubject.asObservable();

    fetch(brandId: string): Observable<any> {
        return this.http.get(Config.API + '/price-sheets/' + brandId + '/published')

            .pipe(catchError(this.handleError.bind(this)));
    }

    fetchAll(brandId: string): Observable<any> {
        return this.http.get(Config.API + '/price-sheets/' + brandId)

            .pipe(catchError(this.handleError.bind(this)));
    }

    putData(brandId: string, data: any): Observable<any> {
      const body = JSON.stringify({data: data});
      return this.http.put(Config.API + '/price-sheets/' + brandId, body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }

    postData(brandId: string, data: any): Observable<any> {
      const body = JSON.stringify({data: data});
      return this.http.post(Config.API + '/price-sheets/' + brandId, body, {headers: contentHeaders})

          .pipe(catchError(this.handleError.bind(this)));
    }

  emitIsSaved() {
    this.isSavedSubject.next();
  }

}
